import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.filter";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.typed.uint8-array";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-property";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import react_1, { createContext, useReducer, useEffect, useMemo, useContext } from 'react';
import crypto from 'crypto';

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var common = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function fromStorage(value) {
    return value !== null ? JSON.parse(value) : null;
  }

  function readItem(storage, key) {
    try {
      var storedValue = storage.getItem(key);
      return fromStorage(storedValue);
    } catch (e) {
      return null;
    }
  }

  function toStorage(value) {
    return JSON.stringify(value);
  }

  function writeItem(storage, key, value) {
    try {
      if (value !== null) {
        storage.setItem(key, toStorage(value));
      } else {
        storage.removeItem(key);
      }

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  function useInitialState(storage, key, defaultState) {
    var defaultStateRef = react_1.useRef(defaultState);
    return react_1.useMemo(function () {
      var _a;

      return (_a = readItem(storage, key)) !== null && _a !== void 0 ? _a : defaultStateRef.current;
    }, [key, storage]);
  }

  exports.useInitialState = useInitialState;

  function useStorageWriter(storage, key, state) {
    var _a = react_1.useState(undefined),
        writeError = _a[0],
        setWriteError = _a[1];

    react_1.useEffect(function () {
      writeItem(storage, key, state)["catch"](function (error) {
        if (!error || !error.message || error.message !== (writeError === null || writeError === void 0 ? void 0 : writeError.message)) {
          setWriteError(error);
        }
      });

      if (writeError) {
        return function () {
          setWriteError(undefined);
        };
      }
    }, [state, key, writeError, storage]);
    return writeError;
  }

  exports.useStorageWriter = useStorageWriter;

  function useStorageListener(storage, key, defaultState, onChange) {
    var defaultStateRef = react_1.useRef(defaultState);
    var onChangeRef = react_1.useRef(onChange);
    var firstRun = react_1.useRef(true);
    react_1.useEffect(function () {
      var _a;

      if (firstRun.current) {
        firstRun.current = false;
        return;
      }

      onChangeRef.current((_a = readItem(storage, key)) !== null && _a !== void 0 ? _a : defaultStateRef.current);
    }, [key, storage]);
    react_1.useEffect(function () {
      function onStorageChange(event) {
        var _a;

        if (event.key === key) {
          onChangeRef.current((_a = fromStorage(event.newValue)) !== null && _a !== void 0 ? _a : defaultStateRef.current);
        }
      }

      if (typeof window !== 'undefined') {
        window.addEventListener('storage', onStorageChange);
        return function () {
          window.removeEventListener('storage', onStorageChange);
        };
      }
    }, [key]);
  }

  exports.useStorageListener = useStorageListener;
});
var state = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function useStorageState(storage, key, defaultState) {
    if (defaultState === void 0) {
      defaultState = null;
    }

    var _a = react_1.useState(common.useInitialState(storage, key, defaultState)),
        state = _a[0],
        setState = _a[1];

    common.useStorageListener(storage, key, defaultState, setState);
    var writeError = common.useStorageWriter(storage, key, state);
    return [state, setState, writeError];
  }

  exports["default"] = useStorageState;
});
var reducer = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var FORCE_STATE_ACTION = '__FORCE_STATE_INTERNAL_API__';

  function isForceStateAction(action) {
    return typeof action === 'object' && action !== null && 'type' in action && action.type === FORCE_STATE_ACTION;
  }

  function addForceStateActionToReducer(reducer) {
    return function (state, action) {
      if (isForceStateAction(action)) return action.payload;
      return reducer(state, action);
    };
  }

  function useStorageReducer(storage, key, reducer, defaultInitialArg, defaultInit) {
    if (defaultInit === void 0) {
      defaultInit = function defaultInit(x) {
        return x;
      };
    }

    var defaultState = defaultInit(defaultInitialArg);

    var _a = react_1.useReducer(addForceStateActionToReducer(reducer), common.useInitialState(storage, key, defaultState)),
        state = _a[0],
        dispatch = _a[1];

    common.useStorageListener(storage, key, defaultState, function (newValue) {
      dispatch({
        type: FORCE_STATE_ACTION,
        payload: newValue
      });
    });
    var writeError = common.useStorageWriter(storage, key, state);
    return [state, dispatch, writeError];
  }

  exports["default"] = useStorageReducer;
});
var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.useStorageState = state["default"];
  exports.useStorageReducer = reducer["default"];
});

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

var isClient = typeof window === 'object';

var formatCurrencyString = function formatCurrencyString(_ref) {
  var value = _ref.value,
      currency = _ref.currency,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? isClient ? navigator.language : 'en-US' : _ref$language;
  value = parseInt(value);
  var numberFormat = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol'
  });
  var parts = numberFormat.formatToParts(value);
  var zeroDecimalCurrency = true;

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (part.type === 'decimal') {
        zeroDecimalCurrency = false;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  value = zeroDecimalCurrency ? value : value / 100;
  return numberFormat.format(value.toFixed(2));
};

function useLocalStorageReducer(key, reducer, initialState) {
  var dummyStorage = {
    getItem: function getItem() {
      return null;
    },
    setItem: function setItem() {},
    removeItem: function removeItem() {}
  };
  return dist.useStorageReducer(isClient ? window.localStorage : dummyStorage, key, reducer, initialState);
}

var getCheckoutData = {
  stripe: function stripe(cart) {
    var lineItems = [];

    for (var sku in cart.cartDetails) {
      lineItems.push({
        price: sku,
        quantity: cart.cartDetails[sku].quantity
      });
    }

    var options = {
      mode: 'payment',
      lineItems: lineItems,
      successUrl: cart.successUrl,
      cancelUrl: cart.cancelUrl,
      billingAddressCollection: cart.billingAddressCollection ? 'required' : 'auto',
      submitType: 'auto'
    };

    if (_optionalChain([cart, 'access', function (_) {
      return _.allowedCountries;
    }, 'optionalAccess', function (_2) {
      return _2.length;
    }])) {
      options.shippingAddressCollection = {
        allowedCountries: cart.allowedCountries
      };
    }

    return options;
  }
};

function checkoutHandler(cart, checkoutOptions) {
  var serviceProperty = '';
  if (cart.stripe) serviceProperty = 'stripe';
  var needsCheckoutData = cart.mode === 'client-only';
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(parameters) {
      var options, _yield$checkoutOption, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (serviceProperty) {
                _context.next = 2;
                break;
              }

              throw new Error('No compatible API has been defined, your options are: Stripe');

            case 2:
              if (checkoutOptions.modes.includes(cart.mode)) {
                _context.next = 4;
                break;
              }

              throw new Error("Invalid checkout mode '".concat(cart.mode, "' was chosen. The valid modes are ").concat(new Intl.ListFormat().format(checkoutOptions.modes), "."));

            case 4:
              options = {
                sessionId: _optionalChain([parameters, 'optionalAccess', function (_3) {
                  return _3.sessionId;
                }])
              };
              if (needsCheckoutData) options = getCheckoutData.stripe(cart);
              _context.t0 = checkoutOptions;
              _context.t1 = serviceProperty;
              _context.next = 10;
              return cart[serviceProperty];

            case 10:
              _context.t2 = _context.sent;
              _context.t3 = options;
              _context.t4 = parameters;
              _context.next = 15;
              return _context.t0[_context.t1].call(_context.t0, _context.t2, _context.t3, _context.t4);

            case 15:
              _yield$checkoutOption = _context.sent;
              error = _yield$checkoutOption.error;

              if (!error) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return", error);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

var rnds8 = new Uint8Array(16);

function rng() {
  return crypto.randomFillSync(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */


var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var _i = 0; _i < 16; ++_i) {
      buf[offset + _i] = rnds[_i];
    }

    return buf;
  }

  return stringify(rnds);
}

var cartInitialState = {
  lastClicked: '',
  shouldDisplayCart: false,
  stripe: null
};

function cartReducer(cart, action) {
  switch (action.type) {
    case 'store-last-clicked':
      return _objectSpread({}, cart, {
        lastClicked: action.id
      });

    case 'cart-click':
      return _objectSpread({}, cart, {
        shouldDisplayCart: !cart.shouldDisplayCart
      });

    case 'cart-hover':
      return _objectSpread({}, cart, {
        shouldDisplayCart: true
      });

    case 'close-cart':
      return _objectSpread({}, cart, {
        shouldDisplayCart: false
      });

    case 'stripe-changed':
      return _objectSpread({}, cart, {
        stripe: action.stripe
      });

    default:
      return cart;
  }
}

var cartValuesInitialState = {
  cartDetails: {},
  totalPrice: 0,
  cartCount: 0
};

function Entry(productData, quantity, currency, language) {
  var getProductId = function getProductId() {
    if (productData.id) {
      return productData.id;
    }

    if (productData.price_id) {
      return productData.price_id;
    }

    if (productData.sku_id) {
      return productData.sku_id;
    }

    if (productData.sku) {
      return productData.sku;
    }

    return v4();
  };

  return _objectSpread({}, productData, {
    id: getProductId(),
    quantity: quantity,

    get value() {
      return this.price * this.quantity;
    },

    get formattedValue() {
      return formatCurrencyString({
        value: this.value,
        currency: currency,
        language: language
      });
    }

  });
}

function cartValuesReducer(state, action) {
  function createEntry(product, count) {
    var entry = Entry(product, count, action.currency, action.language);
    return {
      cartDetails: _objectSpread({}, state.cartDetails, _defineProperty({}, entry.id, entry)),
      totalPrice: state.totalPrice + product.price * count,
      cartCount: state.cartCount + count
    };
  }

  function updateEntry(sku, count) {
    var cartDetails = _objectSpread({}, state.cartDetails);

    var entry = cartDetails[sku];
    if (entry.quantity + count <= 0) return removeEntry(sku);
    cartDetails[sku] = Entry(entry, entry.quantity + count, action.currency, action.language);
    return {
      cartDetails: cartDetails,
      totalPrice: state.totalPrice + entry.price * count,
      cartCount: state.cartCount + count
    };
  }

  function removeEntry(sku) {
    var cartDetails = _objectSpread({}, state.cartDetails);

    var totalPrice = state.totalPrice - cartDetails[sku].value;
    var cartCount = state.cartCount - cartDetails[sku].quantity;
    delete cartDetails[sku];
    return {
      cartDetails: cartDetails,
      totalPrice: totalPrice,
      cartCount: cartCount
    };
  }

  function updateQuantity(sku, quantity) {
    var entry = state.cartDetails[sku];
    return updateEntry(sku, quantity - entry.quantity);
  }

  switch (action.type) {
    case 'add-item-to-cart':
      if (action.count <= 0) break;
      if (action.product.id in state.cartDetails) return updateEntry(action.product.id, action.count);
      return createEntry(action.product, action.count);

    case 'increment-item':
      if (action.count <= 0) break;
      if (action.id in state.cartDetails) return updateEntry(action.id, action.count);
      break;

    case 'decrement-item':
      if (action.count <= 0) break;
      if (action.id in state.cartDetails) return updateEntry(action.id, -action.count);
      break;

    case 'set-item-quantity':
      if (action.count < 0) break;
      if (action.id in state.cartDetails) return updateQuantity(action.id, action.quantity);
      break;

    case 'remove-item-from-cart':
      if (action.id in state.cartDetails) return removeEntry(action.id);
      break;

    case 'clear-cart':
      return cartValuesInitialState;

    case 'load-cart':
      if (!action.shouldMerge) state = _objectSpread({}, cartValuesInitialState);

      for (var sku in action.cartDetails) {
        var entry = action.cartDetails[sku];
        if (action.filter && !action.filter(entry)) continue;
        state = createEntry(entry, entry.quantity);
      }

      return state;

    default:
      return state;
  }

  console.warn('Invalid action arguments', action);
  return state;
}

var _jsxFileName = "/Users/nickdejesus/Code/hooks/use-shopping-cart/use-shopping-cart/src/index.js";
var CartContext = createContext([_objectSpread({
  lastClicked: '',
  shouldDisplayCart: false
}, cartValuesInitialState), function () {}]);

function CartProvider(_ref3) {
  var children = _ref3.children,
      mode = _ref3.mode,
      stripe = _ref3.stripe,
      successUrl = _ref3.successUrl,
      cancelUrl = _ref3.cancelUrl,
      currency = _ref3.currency,
      _ref3$language = _ref3.language,
      language = _ref3$language === void 0 ? isClient ? navigator.language : 'en-US' : _ref3$language,
      _ref3$billingAddressC = _ref3.billingAddressCollection,
      billingAddressCollection = _ref3$billingAddressC === void 0 ? false : _ref3$billingAddressC,
      _ref3$allowedCountrie = _ref3.allowedCountries,
      allowedCountries = _ref3$allowedCountrie === void 0 ? null : _ref3$allowedCountrie;

  var _useReducer = useReducer(cartReducer, cartInitialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      cart = _useReducer2[0],
      cartDispatch = _useReducer2[1];

  useEffect(function () {
    cartDispatch({
      type: 'stripe-changed',
      stripe: stripe
    });
  }, [stripe]);

  var _useLocalStorageReduc = useLocalStorageReducer('cart-values', cartValuesReducer, cartValuesInitialState),
      _useLocalStorageReduc2 = _slicedToArray(_useLocalStorageReduc, 2),
      cartValues = _useLocalStorageReduc2[0],
      cartValuesDispatch = _useLocalStorageReduc2[1]; // combine dispatches and
  // memoize context value to avoid causing re-renders


  var contextValue = useMemo(function () {
    return [_objectSpread({}, cart, {}, cartValues, {
      mode: mode,
      successUrl: successUrl,
      cancelUrl: cancelUrl,
      currency: currency,
      language: language,
      billingAddressCollection: billingAddressCollection,
      allowedCountries: allowedCountries
    }), function (action) {
      cartDispatch(action);
      cartValuesDispatch(_objectSpread({}, action, {
        currency: currency,
        language: language
      }));
    }];
  }, [cart, cartDispatch, cartValues, cartValuesDispatch, mode, successUrl, cancelUrl, currency, language, billingAddressCollection, allowedCountries]);
  return react_1.createElement(CartContext.Provider, {
    value: contextValue,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92
    }
  }, children);
}

var useShoppingCart = function useShoppingCart() {
  var _useContext = useContext(CartContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      cart = _useContext2[0],
      dispatch = _useContext2[1];

  var lastClicked = cart.lastClicked,
      shouldDisplayCart = cart.shouldDisplayCart,
      cartCount = cart.cartCount,
      cartDetails = cart.cartDetails,
      totalPrice = cart.totalPrice,
      currency = cart.currency,
      language = cart.language;

  var addItem = function addItem(product) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return dispatch({
      type: 'add-item-to-cart',
      product: product,
      count: count
    });
  };

  var removeItem = function removeItem(id) {
    return dispatch({
      type: 'remove-item-from-cart',
      id: id
    });
  };

  var setItemQuantity = function setItemQuantity(id, quantity) {
    return dispatch({
      type: 'set-item-quantity',
      id: id,
      quantity: quantity
    });
  };

  var incrementItem = function incrementItem(id) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return dispatch({
      type: 'increment-item',
      id: id,
      count: count
    });
  };

  var decrementItem = function decrementItem(id) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return dispatch({
      type: 'decrement-item',
      id: id,
      count: count
    });
  };

  var clearCart = function clearCart() {
    return dispatch({
      type: 'clear-cart'
    });
  };

  var storeLastClicked = function storeLastClicked(id) {
    return dispatch({
      type: 'store-last-clicked',
      id: id
    });
  };

  var handleCartClick = function handleCartClick() {
    return dispatch({
      type: 'cart-click'
    });
  };

  var handleCartHover = function handleCartHover() {
    return dispatch({
      type: 'cart-hover'
    });
  };

  var handleCloseCart = function handleCloseCart() {
    return dispatch({
      type: 'close-cart'
    });
  };

  var loadCart = function loadCart(cartDetails) {
    var shouldMerge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return dispatch({
      type: 'load-cart',
      cartDetails: cartDetails,
      shouldMerge: shouldMerge
    });
  };

  var redirectToCheckout = checkoutHandler(cart, {
    modes: ['client-only', 'checkout-session'],
    stripe: function stripe(_stripe, options) {
      return _stripe.redirectToCheckout(options);
    }
  });
  var checkoutSingleItem = checkoutHandler(cart, {
    modes: ['client-only'],
    stripe: function stripe(_stripe2, options, _ref4) {
      var sku = _ref4.sku,
          _ref4$quantity = _ref4.quantity,
          quantity = _ref4$quantity === void 0 ? 1 : _ref4$quantity;
      options.lineItems = [{
        price: sku,
        quantity: quantity
      }];
      return _stripe2.redirectToCheckout(options);
    }
  });
  return {
    cartDetails: cartDetails,
    cartCount: cartCount,
    totalPrice: totalPrice,

    get formattedTotalPrice() {
      return formatCurrencyString({
        value: totalPrice,
        currency: currency,
        language: language
      });
    },

    addItem: addItem,
    removeItem: removeItem,
    setItemQuantity: setItemQuantity,
    incrementItem: incrementItem,
    decrementItem: decrementItem,
    clearCart: clearCart,
    lastClicked: lastClicked,
    storeLastClicked: storeLastClicked,
    shouldDisplayCart: shouldDisplayCart,
    handleCartClick: handleCartClick,
    handleCartHover: handleCartHover,
    handleCloseCart: handleCloseCart,
    redirectToCheckout: redirectToCheckout,
    checkoutSingleItem: checkoutSingleItem,
    loadCart: loadCart
  };
};

export { CartContext, CartProvider, formatCurrencyString, isClient, useShoppingCart };